import type { Region } from "@/types/geodata";

function project(lat: number, lng: number) {
  return `${((lng + 180) / 360) * 100},${((90 - lat) / 180) * 100}`;
}

export function RegionMiniMap({ region }: { region: Region }) {
  const polygon = region.boundary.map((point) => project(point.lat, point.lng)).join(" ");

  return (
    <div className="rounded-md border bg-card p-3">
      <p className="mb-2 text-xs uppercase text-muted-foreground">Region boundary</p>
      <svg viewBox="0 0 100 100" className="h-36 w-full rounded bg-muted" role="img">
        <polygon points={polygon} fill="rgba(248,113,113,.28)" stroke="rgb(248,113,113)" strokeWidth="1" />
        <circle
          cx={((region.coordinates.lng + 180) / 360) * 100}
          cy={((90 - region.coordinates.lat) / 180) * 100}
          r="1.8"
          fill="rgb(251,191,36)"
        />
      </svg>
    </div>
  );
}
